(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NftStarSdk", [], factory);
	else if(typeof exports === 'object')
		exports["NftStarSdk"] = factory();
	else
		root["NftStarSdk"] = factory();
})(this, function() {
return 